<template>
  <div>
    <div class="container">
      <generic-tabs
        :tabs="[
          {
            name: 'tab1',
            label: $t('pending requests'),
            icon: 'fa fa-clock-o',
          },
          { name: 'tab2', label: $t('evaluations'), icon: 'fa fa-check' },
        ]"
        orientation="horizontal"
      >
        <template v-slot:tab1
          ><div class="content">
            <pending-requests
              ref="pending_requests"
              @evaluate="onEvaluate"
            /></div
        ></template>
        <template v-slot:tab2>
          <div class="content">
            <evaluations
              ref="evaluations"
              @create="onCreateEvaluation"
              @view="onViewEvaluation"
              @comment="onComment"
            />
          </div>
        </template>
      </generic-tabs>
    </div>
    <!-- Create/Edit Modal -->
    <credit-analysis-evaluation-modal
      ref="evaluation_modal"
      @saved="onSaved"
      @deny_request="onDenyRequest"
    />
    <credit-analysis-evaluation-detail-modal ref="detail_modal" />
    <deny-modal ref="deny_modal" @denied="onDeniedRequest" />
    <evaluation-comment-modal ref="evaluation_comment_modal" />
  </div>
</template>

<script>
import GenericTabs from "@/components/generic_tabs/Index.vue";
import CreditAnalysisEvaluationModal from "./credit_analysis_evaluation_modal/Index.vue";
import CreditAnalysisEvaluationDetailModal from "./credit_analysis_evaluation_detail_modal/Index.vue";
import DenyModal from "./deny_modal/Index.vue";
import Evaluations from "./Evaluations.vue";
import PendingRequests from "./PendingRequests.vue";
import EvaluationCommentModal from "./evaluation_comment_modal/Index.vue";

export default {
  name: "CreditAnalysisEvaluationsIndex",
  components: {
    GenericTabs,
    Evaluations,
    PendingRequests,
    CreditAnalysisEvaluationModal,
    CreditAnalysisEvaluationDetailModal,
    DenyModal,
    EvaluationCommentModal,
  },
  data() {
    return {};
  },
  methods: {
    onEvaluate(request_uuid) {
      this.$refs.evaluation_modal.open(null, request_uuid);
    },
    onCreateEvaluation() {
      this.$refs.evaluation_modal.open();
    },
    onSaved() {
      this.$refs.evaluations.refresh();
    },
    onViewEvaluation(uuid) {
      this.$refs.detail_modal.open(uuid);
    },
    onDenyRequest(request_uuid) {
      this.$refs.deny_modal.open(request_uuid);
    },
    onDeniedRequest() {
      this.$refs.pending_requests.refresh();
    },
    onComment(evaluation_uuid) {
      this.$refs.evaluation_comment_modal.open(evaluation_uuid);
    },
  },
  created() {},
  mounted() {},
};
</script>

<style scoped>
/* Specific styles for evaluations datatable */
</style>
